module.exports = __webpack_public_path__ + "img/kelebihan-2.1de3c22f.jpg";